import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { orpc } from "@/lib/orpc";
import { PageBody, PageHeader, SectionTitle } from "@/components/layout/page-header";
import { UserCard } from "@/routes/users/-components/user-card";

export const Route = createFileRoute("/users/$userId")({
  ssr: false,
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      orpc.user.getUser.queryOptions({ input: { id: params.userId } }),
    ),
  component: UserPage,
});

function UserPage() {
  const { userId } = Route.useParams();
  const { data } = useSuspenseQuery(orpc.user.getUser.queryOptions({ input: { id: userId } }));

  return (
    <>
      <PageHeader title={data.name} eyebrow={data.email} />
      <PageBody className="max-w-2xl">
        <SectionTitle title="Profile" />
        <UserCard user={data} />
      </PageBody>
    </>
  );
}
